import React, { useState, useEffect } from 'react';
import { DillModal } from '../../../general/Dill/DillModal';
import { DillButton } from '../../../general/Dill/DillButton';
import { isHTML } from '../../../../utils/helpers';
import { AppInputField } from '../../../general/AppInputField/AppInputField';

const ApprovalMessageModal = ({
  open,
  handleClose,
  onSubmit,
  message,
  subjectLine = '',
  title = 'Add Approval Message',
}: {
  open: boolean;
  handleClose: () => void;
  onSubmit: (data: { message: string; subjectLine: string }) => void;
  message: string;
  subjectLine?: string;
  title?: string;
}) => {
  const [text, setText] = useState('');
  const [subject, setSubject] = useState('');

  useEffect(() => {
    if (open) {
      setText(message);
      setSubject(subjectLine);
    }
  }, [open, message, subjectLine]);

  const handleCloseModal = () => {
    setText('');
    setSubject('');
    handleClose();
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title={title}
      footer={
        <>
          <DillButton label="Close" variant="secondary" onClick={handleCloseModal} />
          <DillButton
            label="Save"
            onClick={() => {
              onSubmit({ message: text, subjectLine: subject });
              handleClose();
            }}
          />
        </>
      }>
      <AppInputField label="Subject Line" value={subject} onTextChange={(val) => setSubject(val)} />
      <AppInputField
        label="Message"
        value={text}
        inputType="textarea"
        onTextChange={(val) => setText(val)}
      />
      <div>
        <div className="mb-2 text-sm font-semibold">Preview</div>
        {isHTML(text) ? <div dangerouslySetInnerHTML={{ __html: text }} /> : <p>{text}</p>}
      </div>
    </DillModal>
  );
};

export default ApprovalMessageModal;
